import { Headset, LucideIcon, ThumbsUp, Zap } from "lucide-react";

interface ValuePropItemProps {
  icon: LucideIcon;
  title: string;
  description: string;
  color: {
    bg: string;
    iconBg: string;
    iconColor: string;
  };
}

function ValuePropItem({
  icon: Icon,
  title,
  description,
  color,
}: ValuePropItemProps) {
  return (
    <div className={`flex justify-center gap-4 rounded-xl ${color.bg} p-4`}>
      <div>
        <div
          className={`flex h-16 w-16 items-center justify-center rounded-full ${color.iconBg} ${color.iconColor}`}
        >
          <Icon color="currentColor" />
        </div>
      </div>
      <div>
        <div className="text-lg font-semibold">{title}</div>
        <div className="text-gray-500 mt-2">{description}</div>
      </div>
    </div>
  );
}

export function ValueProps() {
  const items = [
    {
      icon: Headset,
      title: "Reduce Ramp Time by 40%",
      description:
        "Get new employees ramped faster with structured practice that accelerates skill development.",
      color: {
        bg: "bg-white",
        iconBg: "bg-green-100",
        iconColor: "text-green-800",
      },
    },
    {
      icon: ThumbsUp,
      title: "Minimize Bad First Calls",
      description:
        "Ensure every rep is prepared before customer interactions to protect your brand and improve conversion rates.",
      color: {
        bg: "bg-white",
        iconBg: "bg-yellow-100",
        iconColor: "text-yellow-900",
      },
    },
    {
      icon: Zap,
      title: "Identify Coaching Gaps Fast ",
      description:
        "Pinpoint skill gaps across your team to deliver targeted coaching that drives real performance gains.",
      color: {
        bg: "bg-white",
        iconBg: "bg-blue-200",
        iconColor: "text-blue-800",
      },
    },
  ];
  return (
    <div className="flex flex-col gap-5 mt-10">
      {items.map((item, index) => (
        <ValuePropItem key={index} {...item} />
      ))}
    </div>
  );
}
